(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/middleware-account-balance/assets/account-balance.js') >= 0) return;  svs.modules.push('/components/payment/middleware-account-balance/assets/account-balance.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$components = svs.components,
  accountBalanceComponent = _svs$components.account_balance,
  analytics = _svs$components.analytics;
const _svs$utils$format = svs.utils.format,
  currency = _svs$utils$format.Currency,
  currencyFromJupiterString = _svs$utils$format.CurrencyFromJupiterString;
const InteractionContext = svs.components.payment.common.context.InteractionContext;
const MiddlewarePaymentError = svs.components.payment.common.error.MiddlewarePaymentError;
const common = svs.components.payment.common;
const isWager = svs.components.payment.createWager.utils.isWager;
const _svs$utils = svs.utils,
  form = _svs$utils.form,
  products = _svs$utils.products;
const urlMapping = svs.core.urlMapping;
const getAccountBalance = () => new Promise(resolve => {
  accountBalanceComponent.get(true, balance => {
    resolve(currencyFromJupiterString(balance));
  });
});
const trackDepositAction = productId => {
  analytics.trackEvent({
    category: 'overlays',
    action: 'deposit',
    opt_label: products.getDisplayName(productId)
  });
};
const accountBalance = onInteraction => _ref => {
  let payment = _ref.payment,
    _ref$userContext = _ref.userContext,
    userContext = _ref$userContext === void 0 ? {} : _ref$userContext;
  return async next => {
    const balance = await getAccountBalance();
    const price = payment.getTotalPrice();
    common.logger.info("Checking account balance");
    if (price > balance) {
      common.logger.info("Account balance too low: ".concat(balance, ", price: ").concat(price));
      const wagerCount = payment.count() > 1 ? 'dina' : 'ditt';
      const title = "Du har inte tillr\xE4ckligt med pengar p\xE5 ditt spelkonto f\xF6r att betala ".concat(wagerCount, " spel");
      const messages = ["Saldo: ".concat(currency(balance), " kr"), "Pris: ".concat(currency(price), " kr")];
      const data = {
        balance,
        price,
        wagerCount: payment.count()
      };
      try {
        common.logger.info('Not enough money, showing dialog to deposit money.');
        const result = await onInteraction(new InteractionContext(InteractionContext.Severity.ERROR, InteractionContext.Code.NOT_ENOUGH_MONEY, data, title, messages));
        const _payment$getPayableIt = payment.getPayableItems(),
          _payment$getPayableIt2 = _slicedToArray(_payment$getPayableIt, 1),
          firstPayable = _payment$getPayableIt2[0];
        if (isWager(firstPayable)) {
          const productId = firstPayable.bets[0].productId;
          trackDepositAction(productId);
        }

        const returnUrl = common.getReturnUrl(window.location, result);
        const returnQuery = userContext.returnQuery;
        if (returnQuery) {
          const newParamEntries = returnQuery instanceof URLSearchParams ? returnQuery.entries() : Object.entries(returnQuery);
          for (const _ref2 of newParamEntries) {
            var _ref3 = _slicedToArray(_ref2, 2);
            const key = _ref3[0];
            const value = _ref3[1];
            const existingValuesForEntry = returnUrl.searchParams.getAll(key);

            if (!existingValuesForEntry.includes(value)) {
              returnUrl.searchParams.append(key, value);
            }
          }
        }
        form.postToUrl(urlMapping.get('transactionsHome'), {
          returnUrl
        });
      } catch (err) {
        common.logger.debug(err === null || err === void 0 ? void 0 : err.message, err);
      }
      const mwError = new MiddlewarePaymentError({
        clientCode: MiddlewarePaymentError.ErrorCodes.NOT_ENOUGH_MONEY,
        extraData: {
          balance,
          price
        }
      });
      return next(mwError);
    }
    common.logger.debug("Account balance check successful");
    next();
  };
};
setGlobal('svs.components.payment.middleware.accountBalance', accountBalance);

 })(window);